/** Width of the cloud icon rendered before proposal CO₂ values. */
export const CO2_LABEL_ICON_WIDTH_PX = 20;
/** Gap between the cloud icon and the numeric value. */
export const CO2_LABEL_ICON_GAP_PX = 4;
/** Existing visual shift towards the left when the cloud is present. */
export const CO2_LABEL_ICON_LEFT_SHIFT_PX = 8;

/**
 * Whether an icon + value can stay fully inside a bar. The label is shifted
 * left by 8 px, so it needs the same amount of spare room on the opposite side
 * as well. If one label fails this check, the overview hides every cloud icon.
 */
export const canFitCo2LabelIcon = (
  barWidth: number,
  valueWidth: number,
): boolean =>
  valueWidth +
    CO2_LABEL_ICON_WIDTH_PX +
    CO2_LABEL_ICON_GAP_PX +
    CO2_LABEL_ICON_LEFT_SHIFT_PX * 2 <=
  barWidth;
